import { v4 as uuidv4 } from 'uuid';

export default class PointAndLine {
  id;
  point;  /* string */
  line; /* string */

  constructor(point, line) {
    this.id = uuidv4();
    this.point = point;
    this.line = line;
  }

  get intersectionCords () {
    return this.point
  }

  set intersectionCords (value) {
    this.point = value
  }

  exportData = () => ({
    id: this.id,
    point: this.point.export(),
    line: this.line.export(),
  })

  importData = (data) => ({
    id: data.id,
    point: data.point.import(),
    line: data.line.import(),
  })

  destroy = () => {
    this.point.destroy();
    //this.line.destroy();
  }
}
